import script from "./Order_button.vue?vue&type=script&setup=true&lang=js"
export * from "./Order_button.vue?vue&type=script&setup=true&lang=js"

import "./Order_button.vue?vue&type=style&index=0&id=3d4a0b0d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4a0b0d"]])

export default __exports__